import { Order, Route, RouteStatus } from "@web-app/types";

export const getRouteStatusText = (
  status: RouteStatus,
  isAssignee?: boolean,
) => {
  switch (status) {
    case "INPROGRESS":
      return "In Transit";
    case "COMPLETE":
      return "Completed";
    default:
      if (isAssignee) {
        return "Assigned";
      } else {
        return "Not Started";
      }
  }
};

export const getOrders = (
  route: Route,
  routedOrdersMap: Map<string, Order>,
) => {
  return route.ordersOrder.map((order) => routedOrdersMap.get(order.id));
};

export const getScheduledStartAndEndDateTime = (
  firstOrder?: Order,
  lastOrder?: Order,
) => {
  if (!firstOrder || !lastOrder) {
    return [];
  }

  return [firstOrder.scheduledStartDateTime, lastOrder.scheduledEndDateTime];
};

export const getRouteCompletedAt = (
  orders: (Order | undefined)[],
): Date | null => {
  let max: Date | null = null;
  for (const o of orders) {
    const t = o?.actualEndDateTime ?? o?.actualPickupDateTime;
    if (!t) continue;
    const d = t instanceof Date ? t : new Date(t);
    if (!max || d > max) max = d;
  }
  return max;
};
